export class BaseEntity {
  id: string;

  constructor(object: object = {}) {
    Object.assign(this, object);
  }
}
